
import { LanguageFeature } from "@dndModels/feature";


export class CharacterLanguageFeature {
  language_ids: string[] = [];

  constructor(obj?: any) {
    if (obj) {
      this.language_ids = obj.language_ids ? obj.language_ids : (obj.language_id && obj.language_id !== "" ? [obj.language_id] : []);
    }
  }

  toDBObj(): any {
    return {
      language_ids: this.language_ids
    };
  }
  
  clone(): CharacterLanguageFeature {
    return new CharacterLanguageFeature(this);
  }

  copy(copyMe: CharacterLanguageFeature): void {
    this.language_ids = copyMe.language_ids;
  }

  copyLanguageFeature(copyMe: LanguageFeature): void {
    if (copyMe.type === "Specific" && copyMe.language_ids.length === copyMe.count) {
      this.language_ids = [...copyMe.language_ids];
    }
  }
}